import { DateTime } from "luxon";
import { AuthorizeAcceptSuite } from "shared/AuthorizeAcceptSuite";
import { SessionView } from "shared/mappers/database/session/session";

export const enum PaymentType {
  CHECK = "check",
  CARD = "card",
}

export type CardDetails = {
  cardNumber: number;
  expirationDate: string;
  cvc: number;
  zip: string;
};

export const formatCardDetails = (
  details: CardDetails,
): AuthorizeAcceptSuite.CardData => ({
  cardNumber: details.cardNumber?.toString() ?? "",
  month: details.expirationDate?.split("/")?.[0] ?? "",
  year: details.expirationDate?.split("/")?.[1] ?? "",
  cardCode: details.cvc?.toString() ?? "",
  zip: details.zip,
});

export const getProfileIsExpired = (session: SessionView) => {
  if (
    parseInt(
      String(
        session.society?.societySettingsPublic?.confirmProfileOlderThanDays,
      ),
    ) === -1
  ) {
    return false;
  } else {
    return !(
      Math.floor(
        DateTime.fromISO(
          session.profile?.lastModified?.timestamp ?? "",
        ).diffNow("days").days,
      ) >=
      Number(
        session.society?.societySettingsPublic?.confirmProfileOlderThanDays,
      ) *
        -1
    );
  }
};
